import React, { useState } from "react";
import { Menu } from "@base-ui-components/react/menu";
import { Stack, SxProps, Theme, styled } from "@mui/material";
import { EliceIconButton } from "../../icon-button";
import { MoreColumn } from "../../../icons";
import { colors } from "../../../tokens";
import useAIDTMediaQuery from "../../../hooks/useAIDTMediaQuery";

const StyledPopup = styled(Menu.Popup)`
  display: flex;
  flex-direction: column;
  min-width: 150px;
  background: transparent;
  padding-top: 10px;
  border-radius: 8px;
`;

const StyledMenuItem = styled(Menu.Item)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
`;

const StyledMoreTrigger = styled(Menu.Trigger)`
  border: none;
  background-color: #fff;
  padding: 0;
`;

export interface LayoutHeaderSubTitleProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>
}

const LayoutHeaderSubTitle = ({ children, sx }: LayoutHeaderSubTitleProps): JSX.Element => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { isTablet } = useAIDTMediaQuery();

  return (
    <Stack direction="row" spacing={2} alignItems="center" sx={sx}>
      {isTablet ? (
        <Menu.Root open={menuOpen} onOpenChange={setMenuOpen}>
          <StyledMoreTrigger>
            <EliceIconButton width={48} height={48} backgroundColor={colors.bluepurple[100]} borderRadius={12}>
              <MoreColumn />
            </EliceIconButton>
          </StyledMoreTrigger>
          <Menu.Portal>
            <Menu.Positioner align="start">
              <StyledPopup>
                <Menu.Arrow />
                {React.Children.map(children, (child, index) => (
                  <StyledMenuItem key={index}>{child}</StyledMenuItem>
                ))}
              </StyledPopup>
            </Menu.Positioner>
          </Menu.Portal>
        </Menu.Root>
      ) : (
        children
      )}
    </Stack>
  );
};

export default LayoutHeaderSubTitle;
